// Universal helper function to format any string into a safe test ID
export const formatTestId = (input: string): string => {
  if (typeof input !== "string") {
    return "";
  }
  return input
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};
